import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=f388f518&scoped=true"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"
import style0 from "./Default.vue?vue&type=style&index=0&id=f388f518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f388f518",
  null
  
)

export default component.exports